export default "__VITE_ASSET__6371d44b__"